import React, { Component, Dispatch, SetStateAction } from 'react'

import { AcademicComponentEditorLayout } from './../index'
import { IQuestionEditor, IQuestionEditorState, ISettingsTabsEditorAcademicComponent, TypeCallbackFunctionEditor, TypeStreamCallbackFunctionEditor } from './academicComponentEditorFunctions'

interface IAcademicComponentEditorComponentProps {
    settings: ISettingsTabsEditorAcademicComponent
    open: boolean
    loading?: boolean
    hideClose?: boolean
    showSaveAll?: boolean
    disableAll?: boolean
    disableButtonSaveAll?: boolean
    disableEditDuration?: boolean
    automaticDuration?: number
    currentQuestion?: IQuestionEditor | IQuestionEditorState
    children: React.ReactNode
    onClickSaveAll?: TypeCallbackFunctionEditor
    streamAllData?: TypeStreamCallbackFunctionEditor
    handleClose?: ()=>void
    onClickOpenPanel?: ()=>void
    setIsCharacterizationSurvey?: Dispatch<SetStateAction<boolean>>
}

interface IAcademicComponentEditorComponentState {}

class AcademicComponentEditorComponent extends Component<IAcademicComponentEditorComponentProps, IAcademicComponentEditorComponentState> {
    render() {
        return (
            <AcademicComponentEditorLayout
                {...this.props}
            />
        )
    }
}

export default React.memo(AcademicComponentEditorComponent)
